import React from "react";
import { useSpring, animated } from "@react-spring/web";

const ComingSoon = () => {
  const props = useSpring({
    from: { opacity: 0, transform: "translateY(-20px)" },
    to: { opacity: 1, transform: "translateY(0px)" },
    config: { duration: 1200 },
  });

  return (
    <div className="flex w-full py-8 my-8 box-border justify-center items-center relative h-36">
      <div className="absolute inset-0 bg-gradient-to-r from-blue-50/50 to-blue-100/50 rounded-2xl"></div>
      <div className="absolute w-24 h-24 rounded-full bg-blue-200/30 blur-xl top-0 left-10"></div>
      <div className="absolute w-32 h-32 rounded-full bg-blue-100/30 blur-xl bottom-0 right-10"></div>

      <animated.div
        style={props}
        className="relative z-10 text-5xl font-mazzardbold bg-clip-text text-transparent bg-gradient-to-r from-blue-800 to-blue-500 flex flex-col items-center"
      >
        <span>Coming Soon!</span>
        <div className="text-base text-gray-600 mt-2 font-normal">
          We're working hard to bring you the best cab experience
        </div>
      </animated.div>
    </div>
  );
};

export default ComingSoon;
